<div class="ng-scope">
    <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#">CASHPRO BATCH</a>
    </nav>

    <div class="container-fluid" style="margin-bottom: 1em; padding-left: 0; padding-right: 0;">
        <form class="example-form">
            <div class="card">
                <div class="card-header">
                    <button class="btn ng-binding" style="float: right;" (click)="toggle()">
                        {{buttonName}}
                    </button>
                </div>

                <div class="card-body animate-show-hide" id="filterGroup" *ngIf="ShowFilters">
                    <div class="row">
                        <div class="col-sm-1">
                            <b>
                                Client
                            </b>
                        </div>

                        <div class="col-sm-11">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let cust of custs" [value]="cust.value">
                                        {{cust.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 0.5em;">
                        <div class="col-sm-1">
                            <b>
                                From
                            </b>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="picker" name="from" id="from">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-1">
                            <b>
                                To
                            </b>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="pickers" name="to" id="to">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="pickers"></mat-datepicker-toggle>
                                <mat-datepicker #pickers></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-2">
                            <button ng-click="$ctrl.searchClicked()" type="button" class="btn btn-primary">
                                SEARCH
                            </button>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 4em;">
                        <div class="col-sm-3">
                            <b>
                                Update ACH/ECHECK #
                            </b>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field appearance="fill">
                                <input matInput type="text">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <button type="reset" class="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </div>
                </div>